export default "__VITE_ASSET__DrchbY74__"